import { useState } from "react";

import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { MessageSquare, Send, CheckCheck, Eye, AlertTriangle } from "lucide-react";
import Card, { CardContent } from "../../../../Component/Common/Card";
import DateRangePicker from "../../../../Component/Common/DateRangePicker";

export default function Whatsappmessage() {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [dateFilter, setDateFilter] = useState("");

  const [dateType, setDateType] = useState("today");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const data = [
    { name: "Rahul", phone: "9876543210", status: "Sent", date: "2026-03-10" },
    { name: "Amit", phone: "9876500000", status: "Delivered", date: "2026-03-11" },
    { name: "Neha", phone: "9876512345", status: "Read", date: "2026-03-11" },
    { name: "Karan", phone: "9876599999", status: "Pending", date: "2026-03-12" },
    { name: "Pooja", phone: "9876501234", status: "Fail", date: "2026-03-12" },
    { name: "Riya", phone: "9876508888", status: "Error", date: "2026-03-12" }
  ];

  /* Daily Message Activity Data */
  const chartData = [
    { name: "Mon", value: 120 },
    { name: "Tue", value: 240 },
    { name: "Wed", value: 180 },
    { name: "Thu", value: 310 },
    { name: "Fri", value: 220 },
    { name: "Sat", value: 150 },
    { name: "Sun", value: 90 }
  ];


  const getDateRange = () => {
  const today = new Date();
  let start = null;
  let end = null;

  switch (dateType) {
    case "today":
      start = new Date(today.setHours(0,0,0,0));
      end = new Date();
      break;

    case "yesterday":
      const y = new Date();
      y.setDate(y.getDate() - 1);
      start = new Date(y.setHours(0,0,0,0));
      end = new Date(y.setHours(23,59,59,999));
      break;

    case "currentWeek":
      const cw = new Date();
      const day = cw.getDay();
      start = new Date(cw.setDate(cw.getDate() - day));
      end = new Date();
      break;

    case "lastWeek":
      const lw = new Date();
      const lwDay = lw.getDay();
      end = new Date(lw.setDate(lw.getDate() - lwDay - 1));
      start = new Date(end);
      start.setDate(end.getDate() - 6);
      break;

    case "currentMonth":
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date();
      break;

    case "lastMonth":
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0);
      break;

    case "custom":
      start = startDate;
      end = endDate;
      break;

    default:
      break;
  }

  return { start, end };
};
  /* Main Chart Color */
  const activityColor = "#2563EB"; // Blue

  const filtered = data.filter((i) => {
    const searchMatch =
      i.name.toLowerCase().includes(search.toLowerCase()) ||
      i.phone.includes(search);

    const statusMatch = statusFilter === "All" || i.status === statusFilter;

    const { start, end } = getDateRange();

    const dateMatch = !start || !end
      ? true
      : new Date(i.date) >= start && new Date(i.date) <= end;

    return searchMatch && statusMatch && dateMatch;
  });

  const total = filtered.length;
  const sent = filtered.filter((d) => d.status === "Sent").length;
  const delivered = filtered.filter((d) => d.status === "Delivered").length;
  const read = filtered.filter((d) => d.status === "Read").length;
  const pending = filtered.filter((d) => d.status === "Pending").length;
  const fail = filtered.filter((d) => d.status === "Fail").length;

  const statusColor = (status) => {
    switch (status) {
      case "Sent":
        return "text-blue-600";
      case "Delivered":
        return "text-green-600";
      case "Read":
        return "text-purple-600";
      case "Pending":
        return "text-yellow-600";
      case "Fail":
        return "text-red-600";
      case "Error":
        return "text-red-700";
      default:
        return "text-gray-600";
    }
  };

  return (
    <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-slate-50 flex">
      {/* SIDEBAR */}
      <div className="hidden lg:block w-64 bg-white shadow-xl p-6">
        <div className="text-2xl font-bold text-blue-600 mb-8">WA Panel</div>

        <div className="space-y-4 text-gray-600">
          <div className="font-semibold text-blue-600">Dashboard</div>
          <div>Campaigns</div>
          <div>Templates</div>
          <div>Message Logs</div>
          <div>Analytics</div>
          <div>Settings</div>
        </div>
      </div>

      {/* MAIN */}
     <div className="flex-1 p-3 md:p-4 lg:p-6">
        {/* <div className="text-3xl font-bold text-gray-800 mb-8">
          WhatsApp Messaging Dashboard
        </div> */}

        <div className="flex justify-end py-2 gap-2">
          <select
            className="border px-3 py-2 rounded-xl text-sm"
            value={dateType}
            onChange={(e) => setDateType(e.target.value)}
          >
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="currentWeek">Current Week</option>
            <option value="lastWeek">Last Week</option>
            <option value="currentMonth">Current Month</option>
            <option value="lastMonth">Last Month</option>
            <option value="custom">Custom</option>
          </select>

          {dateType === "custom" && (
            <DateRangePicker
              startDate={startDate}
              endDate={endDate}
              onChange={(start, end) => {
                setStartDate(start);
                setEndDate(end);
              }}
            />
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">

            {/* CHART */}
            <div className="md:col-span-2 lg:col-span-8">
                <Card className="rounded-2xl shadow">
                <CardContent className="p-2">
                   <h3 className="font-semibold mb-4 text-base">
                    Daily Message Activity
                    </h3>

                    <ResponsiveContainer width="100%" height={220}>
                    <BarChart data={chartData}>
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Bar dataKey="value" fill={activityColor} radius={[6,6,0,0]} />
                    </BarChart>
                    </ResponsiveContainer>
                </CardContent>
                </Card>
            </div>

            {/* KPI CARDS */}
            <div className="md:col-span-2 lg:col-span-4">
               <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">

                <Card className="rounded-2xl shadow">
                    <CardContent className="p-2 flex items-center justify-between">
                    <div>
                        <p className="text-gray-500 text-sm">Total</p>
                        <p className="text-2xl font-bold">{total}</p>
                    </div>
                    <MessageSquare className="text-blue-600" />
                    </CardContent>
                </Card>

                <Card className="rounded-2xl shadow">
                    <CardContent className="p-2 flex items-center justify-between">
                    <div>
                        <p className="text-gray-500 text-sm">Sent</p>
                        <p className="text-2xl font-bold">{sent}</p>
                    </div>
                    <Send className="text-blue-500" />
                    </CardContent>
                </Card>

                <Card className="rounded-2xl shadow">
                    <CardContent className="p-2 flex items-center justify-between">
                    <div>
                        <p className="text-gray-500 text-sm">Delivered</p>
                        <p className="text-2xl font-bold">{delivered}</p>
                    </div>
                    <CheckCheck className="text-green-600" />
                    </CardContent>
                </Card>

                <Card className="rounded-2xl shadow">
                    <CardContent className="p-2 flex items-center justify-between">
                    <div>
                        <p className="text-gray-500 text-sm">Read</p>
                        <p className="text-2xl font-bold">{read}</p>
                    </div>
                    <Eye className="text-purple-600" />
                    </CardContent>
                </Card>

                <Card className="rounded-2xl shadow">
                    <CardContent className="p-2 flex items-center justify-between">
                    <div>
                        <p className="text-gray-500 text-sm">Failed</p>
                        <p className="text-2xl font-bold">{fail}</p>
                    </div>
                    <AlertTriangle className="text-red-600" />
                    </CardContent>
                </Card>

                </div>
            </div>

            </div>

        {/* FILTERS */}
        <div className="flex flex-col sm:flex-row flex-wrap gap-3 mt-4 mb-5">
          <input
            placeholder="Search name or phone..."
            className="border px-3 py-2 rounded-xl text-sm w-full sm:w-64"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
            className="border px-3 py-2 rounded-xl text-sm"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="All">All Status</option>
            <option value="Sent">Sent</option>
            <option value="Delivered">Delivered</option>
            <option value="Read">Read</option>
            <option value="Pending">Pending</option>
            <option value="Fail">Fail</option>
            <option value="Error">Error</option>
          </select>

         

          <button
            className="bg-red-600 text-white px-5 py-2 rounded-xl text-sm"
            onClick={() => {
              setLoading(true);
              setTimeout(() => setLoading(false), 2000);
            }}
          >
            Send Templates
          </button>
        </div>

        {loading && (
          <div className="mb-4 text-red-600 font-semibold animate-pulse">
            Sending WhatsApp messages...
          </div>
        )}

        {/* TABLE */}
        <div className="bg-white rounded-2xl shadow overflow-x-auto">
          <table className="w-full">
            <thead className="bg-blue-600 text-white text-sm">
              <tr>
                <th className="px-3 py-2 text-left text-xs sm:text-sm">Name</th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm">Phone</th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm">Date</th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm">Status</th>
                <th className="px-3 py-2 text-left text-xs sm:text-sm">Action</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((i, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="px-3 py-2 text-xs sm:text-sm">{i.name}</td>
                  <td className="px-3 py-2 text-xs sm:text-sm">{i.phone}</td>
                  <td className="px-3 py-2 text-xs sm:text-sm">{i.date}</td>

                  <td className={`p-3 text-sm font-semibold ${statusColor(i.status)}`}>
                    {i.status}
                  </td>

                  <td className="px-3 py-2 text-xs sm:text-sm">  
                    <button className="bg-blue-600 text-white px-3 py-1 rounded-lg text-xs">
                      View Chat
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
